export const styles = theme => ({
    root: {
        flexGrow: 1,
        justifyContent: "space-between",
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    headline: {
        margin: "3rem 0",
        fontWeight: 100,
    },
    teaser: {
        paddingTop: 135,
        paddingBottom: 135,
        "& h1": {
            fontSize: 42,
            padding: "16px 32px",
            display: "inline-block",
            background: "linear-gradient(180deg, rgba(255,255,255,0.41) 0%, rgba(255,255,255,0.8) 99.12%)",
        },
        "& h6": {
            fontSize: 20,
        },
        backgroundImage: "url('/images/banner/Header_compressed_2880.jpg')",
        backgroundSize: "cover",
    },
    teaserText: {
        marginLeft: 44,
    },
    teaserImage: {
        width: "100%",
    },
    teaserButtons: {
        display: "flex",
        marginTop: 18,
        "& button": {
            padding: "10px 23px",
            float: "left" as const,
        },
        "& h4": {
            padding: "10px 23px",
            marginTop: 25,
            marginLeft: 6,
        }
    },
    productHeadline: {
        "& h2": {
            textAlign: "left",
            margin: "52px 30px",
            fontWeight: "bold",
            fontSize: "1.7rem",
        }
    },
    logos: {
        margin: "96px 0",
        height: "72px",
        opacity: "50%",
        maxWidth: "100%"
    },
    section: {
        marginTop: 32,
        justifyContent: "space-between",
        "& h4": {
            margin: "0.75rem 0",
            fontWeight: "bold",
        },
        minHeight: "200px",
        background: "linear-gradient(179.35deg, #FFFFFF 0%, #EFEFEF 100%)"
    },
    second: {
        backgroundColor: "#f5f5f5",
        padding: "16px 40px 96px 40px",
    },
    divider: {
        margin: "2rem 0",
        height: 6,
        color: "#f5f5f5",
    },
    testimonial: {
        marginTop: 94,
        paddingLeft: 32,
        maxWidth: 500,
        "& h2": {
            fontSize: 42,
            fontWeight: "bold",
        },
        "& h6": {
            marginTop: 36,
            fontSize: 20,
        }
    },
    video: {
        width: "100%",
    },
    videoDisabled: {
        backgroundColor: "#f5f5f5",
        marginTop: 94,
        padding: "96px 32px",
        maxWidth: 500,
        "& h3": {
            fontWeight: "bold",
        },
        "& h6": {
            marginTop: 18,
            fontSize: 14,
        }
    },
    sectionCard: {
        width:"100%",
        "& a": {
            textDecoration: "none",
        },
    },
    featureRow: {},
    feature: {
        backgroundColor: "white",
        padding: 32,
        height: 173,

        "& h3": {
            fontSize: 20,
            marginBottom: 18,
        },
        "& p": {
            fontSize: 16,
        },
        "&:hover": {
            cursor: "pointer",
            transition: "0.5s",
            backgroundColor: "#009",
            "& h3": {
                color: "white",
            },
            "& p": {
                color: "white",
            },
        }
    },
    prefooter: {
        padding: "80px 0",
    },
    prefooterElement: {
        width: 190,
        height: 180,
        backgroundColor: "white",
        padding: 32,
        textAlign: "center" as const,
        "& h3": {
            fontWeight: "bold",
        },
        "& img": {
            marginTop: 30,
        }

    }
});
